export default function Icon1_4() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3884_40310)">
                <g clipPath="url(#clip1_3884_40310)">
                    <path
                        d="M18.6839 38C18.4873 34.6725 19.1962 33.4938 17.1612 32.963C14.1086 32.1669 11.0094 34.8677 8.86572 33.6029C6.72197 32.338 7.47547 27.9387 7.38056 25.5811C7.28567 23.2235 3.14597 24.2029 3.34097 23.4356C3.471 22.924 4.92027 20.9737 7.68889 17.5845C6.14943 11.3532 8.61858 6.80744 15.0964 3.9473C24.813 -0.342858 32.152 6.26042 34.4654 11.4999C36.7788 16.7394 34.7886 24.363 28.9406 28.3994C28.7368 29.483 28.744 32.6725 28.9406 36"
                        stroke="#26AC04"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.372 14.2741C13.7269 16.426 14.4741 17.7171 15.6134 18.1475C16.7528 18.578 18.3323 18.491 20.3521 17.8867C21.0181 20.5702 22.0636 21.5055 23.4884 20.6926C24.9133 19.8796 25.5364 18.8634 25.3576 17.6437C27.9801 17.2693 29.0022 16.1623 28.424 14.3227C27.5568 11.5632 25.2125 10.0915 24.6311 10.3482C24.0497 10.6049 22.5122 11.1992 22.1572 10.3952C21.8022 9.59107 19.8422 9.91365 18.2542 10.6148C16.6663 11.3159 17.1493 9.82355 15.1556 11.2092C13.8263 12.133 13.2318 13.1546 13.372 14.2741Z"
                        stroke="#26AC04"
                        strokeWidth="2.5"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_3884_40310">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
                <clipPath id="clip1_3884_40310">
                    <rect width="40" height="40" fill="white" transform="translate(-6.37415 9.7832) rotate(-23.8228)" />
                </clipPath>
            </defs>
        </svg>
    );
}
